<div
  class="upgrade-modal-container"
  [ngClass]="{
    'interactive-displays-modal': background === 'interactive-displays-graphic',
  }"
>
  <div class="upgrade-modal-panel">
    <div class="upgrade-modal-text">
      <div class="cta-container">
        <streamline-icon
          aria-hidden="true"
          name="circleArrowUp"
          width="16"
          height="16"
          class="rise-blue"
        ></streamline-icon>
        <p class="tw-mb-0">
          {{ cta }} <span class="tw-font-bold">{{ plan }}</span>
        </p>
      </div>
      <h3 class="tw-font-bold">{{ title }}</h3>
      <p>{{ description }}</p>
      @if (bulletPoints && bulletPoints.length > 0) {
        <ul class="feature-bullet-points">
          @for (point of bulletPoints; track point) {
            <li>{{ point }}</li>
          }
        </ul>
      }
      <div class="button-row">
        <a rv-button variant="secondary" target="_blank" [href]="helpLink"
          >Learn More</a
        >
        @if (contactSalesLink) {
          <button rv-button (click)="contactSales()">Contact Sales</button>
        } @else {
          <button rv-button (click)="upgrade()">
            {{ upgradeButtonText || 'Upgrade Plan' }}
          </button>
        }
      </div>
    </div>
  </div>
  <div
    class="upgrade-modal-panel upgrade-feature-graphic"
    [ngClass]="background"
  >
    @if (imageSource) {
      <div class="upgrade-feature-image">
        <img [src]="imageSource" alt="source" />
      </div>
    }
    <button
      type="button"
      mat-icon-button
      class="close text-white tw-mr-[5px]"
      (click)="dismiss()"
      aria-label="Click to close this modal"
    >
      <streamline-icon name="close" width="12" height="12"></streamline-icon>
    </button>
  </div>
</div>
